import { AxiosResponse } from "axios";
import { apiClient } from "@/apps/core-app-onboarding/services/apiClient/apiClient";
import { coreAppOnboardingApiUrls as apiUrl } from "@/apps/core-app-onboarding/services/apiClient/apiUrl";
import { jsonHeader } from "@/apps/core-app-onboarding/services/apiClient/apiHeader";
import { CoreAppOnboardingService } from "@/apps/core-app-onboarding/services/core-app-oboarding.service";
// Request types
import {
  IAcceptSignatureRequest,
  ICreditCheckPermissionRequest,
  ICheckApplicationSourceRequest,
  IInitPersonRegistrationRequest,
  IValidateKioskIdRequest,
  IValidatePersonRegistrationRequest,
  IBaseRequest,
  IUpdateApplicationSourceRequest,
} from "@/apps/core-app-onboarding/types/requests";
// Response types
import {
  AcceptSignatureResponse,
  ApplicationFromRegistrationTagResponse,
  CreditCheckPermissionResponse,
  InitPersonRegistrationResponse,
  ValidateKioskIdResponse,
  ValidatePersonRegistrationResponse,
  CheckApplicationSourceResponse,
  CheckPriorBorrowerResponse,
} from "@/apps/core-app-onboarding/types/responses";
import { IBaseResponse } from "@/apps/core-app-onboarding/models/IBaseResponse";

type NetworkResponse<T> = Promise<AxiosResponse<T>>;

export class APIService implements CoreAppOnboardingService {
  getApplicationFromRegistrationTag(
    personRegistrationTag: string,
    applicationId: string
  ): NetworkResponse<ApplicationFromRegistrationTagResponse> {
    return apiClient.get(
      apiUrl().GET_APPLICATION_FROM_REG_TAG +
        `?personRegistrationTag=${personRegistrationTag}&applicationId=${applicationId}`,
      jsonHeader(
        `personRegistrationTag=${personRegistrationTag}&applicationId=${applicationId}`
      )
    );
  }
  initiatePersonRegistration(
    params: IInitPersonRegistrationRequest
  ): NetworkResponse<InitPersonRegistrationResponse> {
    return apiClient.post(
      apiUrl().INIT_PERSON_REG,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  validatePersonRegistration(
    params: IValidatePersonRegistrationRequest
  ): NetworkResponse<ValidatePersonRegistrationResponse> {
    return apiClient.post(
      apiUrl().VALIDATE_PERSON_REG,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  creditCheckPermission(
    params: ICreditCheckPermissionRequest
  ): NetworkResponse<CreditCheckPermissionResponse> {
    return apiClient.post(
      apiUrl().CREDIT_CHECK_PERMISSION,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  checkApplicationSource(
    params: ICheckApplicationSourceRequest
  ): NetworkResponse<CheckApplicationSourceResponse> {
    return apiClient.post(
      apiUrl().CHECK_APPLICATION_SOURCE,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  updateApplicationSource(
    params: IUpdateApplicationSourceRequest
  ): NetworkResponse<IBaseResponse> {
    return apiClient.post(
      apiUrl().UPDATE_APPLICATION_SOURCE,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  acceptSignature(
    params: IAcceptSignatureRequest
  ): NetworkResponse<AcceptSignatureResponse> {
    return apiClient.post(
      apiUrl().ACCEPT_SIGNATURE,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  validateKioskId(
    params: IValidateKioskIdRequest
  ): NetworkResponse<ValidateKioskIdResponse> {
    return apiClient.post(
      apiUrl().VALIDATE_KIOSK_ID,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
  checkPriorBorrower(
    params: IBaseRequest
  ): NetworkResponse<CheckPriorBorrowerResponse> {
    return apiClient.post(
      apiUrl().CHECK_PRIOR_BORROWER,
      params,
      jsonHeader(JSON.stringify(params))
    );
  }
}
